import React, { useState } from 'react'

import CONS from 'x/config/constants'
import XOverlay from 'xui/components/XOverlay'
import XDateRangePicker from 'xui/components/XDateRangePicker'
import Segment from 'xui/components/Segment'
import HStack from 'xui/components/HStack'
import VStack from 'xui/components/VStack'
import Box from 'xui/components/Box'
import XText from 'xui/components/XText'
import XButton from 'xui/components/XButton'
import dayjs from 'dayjs'

export interface IOverlaySetupSyncErpDocumentCallBack {
  dateFrom?: string
  dateTo?: string
}

interface IOverlaySetupSyncErpDocumentProps {
  isOverlayVisible: boolean
  onClose: () => void
  onSubmit: (callBack: IOverlaySetupSyncErpDocumentCallBack) => void
}

const OPTIONS_TIME_PERIOD = ['ทั้งหมด', 'วันนี้', '3 วัน', '7 วัน', 'ระบุเวลา']

const OverlaySetupSyncErpDocument: React.FC<IOverlaySetupSyncErpDocumentProps> = ({ isOverlayVisible, onClose, onSubmit }) => {
  const todayRange = {
    startDate: dayjs().hour(0).minute(0).second(0).millisecond(0),
    endDate: dayjs().hour(23).minute(59).second(59).millisecond(999),
  }
  const [dateTime, updateDateTime] = useState(todayRange)
  const [segmentIndex, onChangeSegmentIndex] = useState(0) // default "ทั้งหมด"

  const onDateChange = ({ begin, end }: { begin: dayjs.Dayjs; end: dayjs.Dayjs }) => {
    updateDateTime({ startDate: begin, endDate: end })
    onChangeSegmentIndexFunction(4) // switch to "ระบุเวลา"
  }

  const onChangeSegmentIndexFunction = (newIndex: number) => {
    if (newIndex === 0) {
      // ทั้งหมด — no date filter
      updateDateTime(todayRange) // reset แต่ไม่ส่งไป
    } else if (newIndex === 1) {
      // วันนี้
      updateDateTime(todayRange)
    } else if (newIndex === 2) {
      // 3 วัน
      updateDateTime({
        startDate: dayjs().subtract(2, 'days').hour(0).minute(0).second(0).millisecond(0),
        endDate: dayjs().hour(23).minute(59).second(59).millisecond(999),
      })
    } else if (newIndex === 3) {
      // 7 วัน
      updateDateTime({
        startDate: dayjs().subtract(6, 'days').hour(0).minute(0).second(0).millisecond(0),
        endDate: dayjs().hour(23).minute(59).second(59).millisecond(999),
      })
    }
    // newIndex === 4 → ระบุเวลา (ใช้ค่าจาก DateRangePicker)
    onChangeSegmentIndex(newIndex)
  }

  const submitBtn = () => {
    // "ทั้งหมด" = ไม่ส่ง date filter
    if (segmentIndex === 0) {
      onSubmit({})
      return
    }

    const callBack: IOverlaySetupSyncErpDocumentCallBack = {
      dateFrom: dayjs(dateTime.startDate).format(CONS.SERVER_DATETIME_FORMAT),
      dateTo: dayjs(dateTime.endDate).format(CONS.SERVER_DATETIME_FORMAT),
    }
    onSubmit(callBack)
  }

  const isCustomDateRange = segmentIndex === 4

  return (
    <XOverlay
      contentStyle={{ width: 310, alignSelf: 'center', alignContent: 'flex-start' }}
      visible={isOverlayVisible}
      onRequestClose={() => onClose()}
    >
      <Box w='full' p='2' bgColor='white' borderRadius='md' _dark={{ bgColor: 'gray.500' }}>
        <VStack w='full' space='2'>
          <XText variant='active' bold>
            ซิงก์เอกสารจากระบบบัญชี
          </XText>

          <VStack space='1'>
            <XText variant='inactive'>ช่วงเวลาที่เอกสารถูกสร้าง</XText>
            <Segment selectedIndex={segmentIndex} options={OPTIONS_TIME_PERIOD} onSegmentChange={onChangeSegmentIndexFunction} />
          </VStack>

          {/* แสดง DateRangePicker เฉพาะเมื่อเลือก segment ที่ไม่ใช่ "ทั้งหมด" */}
          {segmentIndex !== 0 ? (
            <VStack space='1'>
              <Box justifyContent='center' w='full' h='24'>
                <XDateRangePicker
                  selectedDates={{ begin: dateTime.startDate, end: dateTime.endDate }}
                  onChangeDate={(newDates: { begin: dayjs.Dayjs; end: dayjs.Dayjs }) => onDateChange(newDates)}
                  showTime={false}
                />
              </Box>
            </VStack>
          ) : null}

          <XButton mt='1' onPress={() => submitBtn()}>
            ดำเนินการซิงก์
          </XButton>
        </VStack>
      </Box>
    </XOverlay>
  )
}

export default OverlaySetupSyncErpDocument
